import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { FlavorType, SyrupType } from 'src/app/products/interfaces/models';

import { SyrupProperties } from '@app/api/models';
import { SubformBaseWithSugarContentPropertiesComponent } from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';

@Component({
  selector: 'app-syrup-properties-subform',
  styleUrls: ['./syrup-properties-subform.component.scss'],
  templateUrl: './syrup-properties-subform.component.html',
})
export class SyrupPropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = false;
  DICT_PATH = 'PRODUCTS.SYRUP_PROPERTIES';

  flavorType = FlavorType;
  syrupType = SyrupType;

  static buildForm(fb: FormBuilder, data?: SyrupProperties) {
    return fb.group({
      flavorTypes: [data?.flavorTypes, Validators.required],
      syrupType: [data?.syrupType, Validators.required],
      basedOnExtractAccordingToHungarianFoodCode: [
        data?.basedOnExtractAccordingToHungarianFoodCode,
      ],
      fruitPerVegetablesRatioLessThan50Percent: [
        data?.fruitPerVegetablesRatioLessThan50Percent,
      ],
      // build sugar content properties
      ...SubformBaseWithSugarContentPropertiesComponent.buildFields(data),
    });
  }
}
